document.addEventListener('DOMContentLoaded', function () {
  const backdrop = document.getElementById('itineraryLightbox');
  if (!backdrop) return;

  const imgEl = document.getElementById('itineraryLightboxImg');
  const titleEl = document.getElementById('itineraryLightboxTitle');
  const counterEl = document.getElementById('itineraryLightboxCounter');
  const btnPrev = backdrop.querySelector('.arrow.prev');
  const btnNext = backdrop.querySelector('.arrow.next');
  const btnClose = backdrop.querySelector('.close');

  let groups = {};
  let activeKey = null, activeIndex = 0;

  function buildGroups() {
    groups = {};
    document.querySelectorAll('.itinerary-thumb').forEach(el => {
      const key = el.dataset.gallery;
      (groups[key] ||= []).push({ el, full: el.dataset.full, title: el.dataset.title || '' });
    });
  }

  function open(key, index) {
    activeKey = key; activeIndex = index || 0;
    render();
    backdrop.classList.add('is-open');
    backdrop.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
  }
  function close() {
    backdrop.classList.remove('is-open');
    backdrop.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
  }
  function render() {
    const list = groups[activeKey] || [];
    const item = list[activeIndex] || list[0]; if (!item) return;
    imgEl.src = item.full; imgEl.alt = item.title; titleEl.textContent = item.title || '';
    counterEl.textContent = (activeIndex+1) + ' / ' + list.length;
    const show = list.length > 1;
    btnPrev.style.display = show ? '' : 'none';
    btnNext.style.display = show ? '' : 'none';
  }
  function prev(){ const list = groups[activeKey] || []; activeIndex = (activeIndex-1+list.length)%list.length; render(); }
  function next(){ const list = groups[activeKey] || []; activeIndex = (activeIndex+1)%list.length; render(); }

  // Delegated click handler; rebuild groups on demand
  document.addEventListener('click', function(e){
    const a = e.target.closest('.itinerary-thumb');
    if (!a) return;
    e.preventDefault();
    buildGroups();
    const key = a.dataset.gallery;
    const sibs = (groups[key] || []).map(x => x.el);
    const idx = Math.max(sibs.indexOf(a), 0);
    open(key, idx);
  });

  btnPrev.addEventListener('click', prev);
  btnNext.addEventListener('click', next);
  btnClose.addEventListener('click', close);
  backdrop.addEventListener('click', (e) => { if (e.target === backdrop) close(); });
  document.addEventListener('keydown', (e) => {
    if (!backdrop.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });
});